import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_BANKS, SET_EMPLOYEE_BANK, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_BANK_ISLOADING,
  DELETE_EMPLOYEE_BANK,
  EDIT_EMPLOYEE_BANK,
  GET_EMPLOYEE_BANKS,
  GET_EMPLOYEE_BANK,
  REGISTER_EMPLOYEE_BANK,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeBank from '@/services/employee_bank';
import { Module } from 'vuex';
import { EditEmployeeBank, RegisterEmployeeBank, GetEmployeeBank } from '@/dtos/employee_bank.dto';

const employeeBank: Module<any, {}> = {
  state: {
    employeeBank: {
      data: null,
      isLoading: false,
    },
    employeeBanks: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeBank: (state: { employeeBank: any }) => state.employeeBank,
    employeeBanks: (state: { employeeBanks: any }) => state.employeeBanks,
  },
  mutations: {
    [SET_EMPLOYEE_BANK]: (
      state: { employeeBank: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeBank.data = payload.data) : null,
        (state.employeeBank.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_BANKS]: (
      state: { employeeBanks: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeBanks.data = payload.data) : null,
        (state.employeeBanks.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_BANK]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeBank.registerEmployeeBank(
        payload as RegisterEmployeeBank
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_BANK, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_BANK, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_BANKS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_BANKS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeBank.getEmployeeBanks(
        payload as GetEmployeeBank
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_BANKS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_BANKS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_BANKS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_BANK]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeBank.getEmployeeBanks(
        payload as GetEmployeeBank
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_BANK, { data: result.data.data[0], isLoading: false });
          return result.data.data[0];
        }
        commit(SET_EMPLOYEE_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_BANK, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_BANK]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeBank.editEmployeeBank(
        payload as EditEmployeeBank
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_BANK, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_BANK, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_BANK]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeBank.deleteEmployeeBank(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_BANK, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_BANK, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_BANK_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_BANK, { isLoading: false });
      commit(SET_EMPLOYEE_BANKS, { isLoading: false });
    },
  },
};

export default employeeBank;
